import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Baseline Data Collection Framework',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Section D: Development Staff Capability',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Major Gift Experience',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'majorGiftExperience',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Donor Database management',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'donorDatabaseManagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Board Engagement',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'boardEngagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Grant Writing',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'grantWriting',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Event Management',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'eventManagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Stewardship Programs',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'stewardshipPrograms',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Section E: Organizational Readiness',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Case for Support',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'caseForSupport',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Marketing Materials',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'marketingMaterials',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Digital Presence',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'digitalPresence',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Data Analytics Usage',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'dataAnalyticsUsage',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Volunteer Engagement',
                      value: {
                        '{}': {
                          emphasis: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'volunteerEngagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    orgRecordId: '?1',
  },
  subqueries: {
    assessments: {
      ref: {
        attr: 'attr:ent#!assessments#!asssessment:!affiliate',
      },
      filter: {
        '=': [
          {
            '@.': [
              '!affiliate',
              {
                ref: {
                  entity: '!affiliate',
                },
              },
            ],
          },
          {
            '@$': 'orgRecordId',
          },
        ],
      },
      target: 'ent:!assessments:!assessment',
      selection: {
        '{}': {
          affiliate: {
            '@.': '!affiliate',
          },
          boardSize: {
            '@.': '!board_size',
          },
          newDonors: {
            '@.': '!new_donors',
          },
          staffCount: {
            '@.': '!staff_count',
          },
          girlsServed: {
            '@.': '!girls_served',
          },
          onlineSplit: {
            '@.': '!online_split',
          },
          grantWriting: {
            '@.': '!grant_writing',
          },
          lapsedDonors: {
            '@.': '!lapsed_donors',
          },
          caseForSupport: {
            '@.': '!case_for_support',
          },
          currentRevenue: {
            '@.': '!current_revenue',
          },
          retainedDonors: {
            '@.': '!retained_donors',
          },
          boardEngagement: {
            '@.': '!board_engagement',
          },
          digitalPresence: {
            '@.': '!digital_presence',
          },
          eventManagement: {
            '@.': '!event_management',
          },
          givingFrequency: {
            '@.': '!giving_frequency',
          },
          totalActiveDonors: {
            '@.': '!total_active_donors',
          },
          dataAnalyticsUsage: {
            '@.': '!data_analytics_usage',
          },
          donorLifetimeValue: {
            '@.': '!donor_lifetime_value',
          },
          marketingMaterials: {
            '@.': '!marketing_materials',
          },
          majorGiftExperience: {
            '@.': '!major_gift_experience',
          },
          stewardshipPrograms: {
            '@.': '!stewardship_programs',
          },
          donorDatabaseManagement: {
            '@.': '!donor_database_management',
          },
        },
      },
    },
  },
}
